/**
 * 应用入口文件
 *
 * 初始化 React 应用
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// 导入全局样式（Tailwind CSS v4）
import './index.css'

// 导入应用组件
import App from './App'

/* ============================================
 * 渲染应用
 * ============================================ */

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)